import {
    mapDataToCategories,
    mapDataToCustomTags,
    Columns,
    type TagsConfig,
    type TagUpdateValue,
} from "@/components/react/ReactTableTags";
import TagsTables from "@/components/react/TagsTables";
import { LINE_TAGS } from "@/lib/ManufacturingTagsEditor.generated";
import { LINE_TAGS as LINE_TAG_VALUES } from "@/lib/ManufacturingTags.generated";

import { LINE_TAGS_ACCESS } from "@/lib/ManufacturingTags.generated";
import type { ITags } from "@/lib/Models";

import UserDocumentationLink from "@/components/UserDocumentationLink";

/**
 * The line type is stored in the tags object but is handled separately in the UI
 * as a dedicated select (dropdown) instead of a tag field.
 */
export const isSpecialTag = (tagName: string) => tagName === LINE_TAG_VALUES.type;

type Props = {
    tags: ITags;
    onChangeCell: (name: string) => (value: TagUpdateValue) => void;
};

const LineEditTags = (props: Props) => {
    // TODO - add support for source
    const line_tags = { ...LINE_TAGS };
    // Remove special tags like "type" which are handled separately and should not be editable as normal tags.
    line_tags.values = line_tags.values.filter(el => !isSpecialTag(el.name));
    const tagCategories = mapDataToCategories(props.tags, line_tags as TagsConfig, LINE_TAGS_ACCESS);
    const customTags = mapDataToCustomTags(props.tags, line_tags as TagsConfig).filter(tag => !isSpecialTag(tag.key));

    return (
        <>
            <div className="text-right mb-3">
                <UserDocumentationLink link_key={"lines"} />
            </div>
            <TagsTables
                categories={tagCategories}
                columns={Columns}
                onChangeCell={props.onChangeCell}
                customTags={customTags}
            />
        </>
    );
};

export default LineEditTags;
